import { formatQtyByUom, shouldCategoryDefaultOpen } from './stockGroups'

export type DispatchEditorLine = {
  materialId: string
  materialCode: string
  materialName: string
  uom: string
  qty: number
  maxQty: number
  categoryId?: string
  categoryName?: string
}

export type DispatchEditorCategoryGroup = {
  categoryKey: string
  categoryName: string
  items: DispatchEditorLine[]
  qtyFilledByUom: Record<string, number>
  itemCount: number
}

const NONE_KEY = '__none__'
const NONE_NAME = 'Tanpa kategori'

export function isLineVisible(line: DispatchEditorLine, showAll: boolean): boolean {
  if (showAll) return true
  return line.maxQty > 0 || line.qty > 0
}

export function aggregateFilledQtyByUom(items: DispatchEditorLine[]): Record<string, number> {
  const out: Record<string, number> = {}
  for (const item of items) {
    if (item.qty <= 0) continue
    out[item.uom] = (out[item.uom] ?? 0) + item.qty
  }
  return out
}

export function categoryHasFilledQty(items: DispatchEditorLine[]): boolean {
  return items.some((i) => i.qty > 0)
}

export function groupEditorLinesByCategory(
  lines: DispatchEditorLine[],
  showAll: boolean,
): DispatchEditorCategoryGroup[] {
  const visible = lines.filter((line) => isLineVisible(line, showAll))
  const map = new Map<string, DispatchEditorLine[]>()
  const names = new Map<string, string>()
  for (const line of visible) {
    const key = line.categoryId?.trim() || NONE_KEY
    const name = line.categoryName?.trim() || NONE_NAME
    if (!map.has(key)) map.set(key, [])
    map.get(key)!.push(line)
    names.set(key, name)
  }
  const groups: DispatchEditorCategoryGroup[] = [...map.entries()].map(([categoryKey, items]) => ({
    categoryKey,
    categoryName: names.get(categoryKey) ?? NONE_NAME,
    items,
    qtyFilledByUom: aggregateFilledQtyByUom(items),
    itemCount: items.length,
  }))
  groups.sort((a, b) => {
    if (a.categoryKey === NONE_KEY) return 1
    if (b.categoryKey === NONE_KEY) return -1
    return a.categoryName.localeCompare(b.categoryName, 'id')
  })
  return groups
}

export function shouldEditorCategoryDefaultOpen(
  group: DispatchEditorCategoryGroup,
  index: number,
  categoryCount: number,
): boolean {
  if (categoryHasFilledQty(group.items)) return true
  return shouldCategoryDefaultOpen(index, categoryCount, false)
}

export function formatEditorCategorySummary(group: DispatchEditorCategoryGroup): string {
  const keys = Object.keys(group.qtyFilledByUom)
  if (keys.length === 0) return ''
  return formatQtyByUom(group.qtyFilledByUom)
}
